import React, { useState, useRef, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import Menu from 'components/Menu';
import { FormTitle, VcEGrid, VcGrid } from 'components/Grid';
import Input from 'components/Material/Input';
import {
  createStyles,
  makeStyles,
  Theme,
  useTheme,
} from '@material-ui/core/styles';
import { Autocomplete } from '@material-ui/lab';
import Select from 'components/Material/Select';

import DateOneSePickersTyping from 'components/DatePicker/DateOneSePickersTyping';

import { Iobject, Ioption } from 'main_type';
import { getSearch, postExcel, snackBarRsp, upload } from 'main_api';

import { Typography, useMediaQuery } from '@material-ui/core';
import Alert from '@material-ui/lab/Alert';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import SearchIcon from '@material-ui/icons/Search';
import EditIcon from '@material-ui/icons/Edit';
import AttachFileIcon from '@material-ui/icons/AttachFile';
import SaveIcon from '@material-ui/icons/Save';
import RefreshIcon from '@material-ui/icons/Refresh';

import { useSnackbar } from 'notistack';
import { setLoadingRedux } from 'reducers/shareData/action';
import {
  getUserInfoRedux,
  getWareHouseListRedux,
} from 'reducers/shareData/selector';
import { isType, userTypeList } from 'main_consts';
import WarehouseModal from 'components/Modal/WareHouseModal';
import Header from 'components/Header';
import {
  getExpressName,
  getDateDayPlus,
  inputChange,
  selectChange,
  getWarehouse,
  formatDate,
  getFindDropDownList,
  getfindDropDownContainerNoList,
} from '../../../main_func';

import { Iresult, Imaster } from './type';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      '& > *': {
        margin: theme.spacing(1),
      },
    },
    input: {
      display: 'none',
    },
  })
);
/** 開櫃影像上傳 */
const UploadOpenCtnrImg = (): JSX.Element => {
  const classes = useStyles();
  const warehouseRedux = useSelector(getWareHouseListRedux);
  const { user, userType, locationCode } = useSelector(getUserInfoRedux);
  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();
  const [formError, setFormError] = useState(false);
  const [submitKey, setSubmitKey] = useState('search');
  const apiName = 'uploadOpenCtnrImg';
  const [rowData, setRowData] = useState<Iresult[]>([]);
  const [openSearchTable, setOpenSearchTable] = useState(false);
  const [randomValue, setRandomValue] = useState(Math.random());
  const [uploadFile, setUploadFile] = useState<File | null>(null);
  const [openCNStatOptions, setOpenCNStatOptions] = useState<Ioption[]>([]);
  const [containerNoOptions, setContainerNoOptions] = useState<string[]>([]);
  const [expressName, setExpressName] = useState('');
  const [warehouseName, setWarehouseName] = useState('');
  const [photo, setPhoto] = useState('');

  const theme = useTheme();

  const isXs = useMediaQuery(theme.breakpoints.only('xs'));
  const isSm = useMediaQuery(theme.breakpoints.only('sm'));
  const isMd = useMediaQuery(theme.breakpoints.only('md'));
  const isLg = useMediaQuery(theme.breakpoints.only('lg'));
  const isXl = useMediaQuery(theme.breakpoints.only('xl'));

  let currentBreakpoint = '未知';
  let description = '';

  if (isXs) {
    currentBreakpoint = 'xs';
    description = '手機（<600px）';
  } else if (isSm) {
    currentBreakpoint = 'sm';
    description = '小型平板（≥600px）';
  } else if (isMd) {
    currentBreakpoint = 'md';
    description = '筆電或中型螢幕（≥900px）';
  } else if (isLg) {
    currentBreakpoint = 'lg';
    description = '桌機（≥1200px）';
  } else if (isXl) {
    currentBreakpoint = 'xl';
    description = '超大螢幕（≥1536px）';
  }

  const masterDefaultValue: Imaster = {
    // 拆櫃日期
    declDate: getDateDayPlus(),
    // 貨櫃號碼
    containerNo: '',
    // 開櫃狀態
    openCtnrStatus: '',
    // 備註
    remark: '',
    fileName: '',
    file: '',
    chkCode1: '',
    warehouse:
      userType === userTypeList.type1[0] || userType === userTypeList.type2[0]
        ? locationCode
        : 'TPEE011S',
    declDateValid: true,
  };
  const [master, setMaster] = useState(masterDefaultValue);

  useEffect(() => {
    const fetchContainerNoOptions = async () => {
      const options = await getfindDropDownContainerNoList(
        formatDate(master.declDate, 'yyyyMMdd'),
        master.warehouse,
        ''
      );
      setContainerNoOptions(options);
    };

    fetchContainerNoOptions();
  }, [master.declDate, master.warehouse]);

  useEffect(() => {
    getFindDropDownList('findDropDownOpenCNStat', {
      warehouse: locationCode,
    }).then((item) => {
      setOpenCNStatOptions(item);
    });
  }, [master.warehouse]);

  useEffect(() => {
    getFindDropDownList('findDropDownOpenCNStat', {
      warehouse: locationCode,
    }).then((item) => {
      setOpenCNStatOptions(item);
    });
    // const list2: Ioption[] = [
    //   { value: 'RI', label: '重覆進倉' },
    //   { value: 'NM', label: '無艙單' },
    //   { value: 'ND', label: '有艙單無報單' },
    //   { value: 'NC', label: '櫃號不符' },
    //   { value: 'NB', label: '主號相同櫃號不符' },
    // ];
    // setUnloadOptions(list2);
    if (
      userType &&
      !(
        isType(userTypeList.admin, userType) ||
        isType(userTypeList.type1, userType) ||
        isType(userTypeList.type6, userType)
      )
    ) {
      setFormError(true);
      enqueueSnackbar(`您無權限使用此功能!`);
    }

    setMaster((prev) => ({ ...prev, warehouse: masterDefaultValue.warehouse }));
  }, [userType]);

  const handleUpload = async (
    e?: React.FormEvent<HTMLFormElement>
  ): Promise<void> => {
    if (e && e.preventDefault) {
      e.preventDefault();
    }
    dispatch(setLoadingRedux(true));

    const formData = new FormData();
    if (uploadFile) {
      formData.append('File', uploadFile);
    }
    // console.log('formData', formData);
    const result = await upload(apiName, {
      file: photo,
      fileName: master.fileName,
      declDate: formatDate(master.declDate, 'yyyyMMdd'),
      containerNo: master.containerNo,
      openCtnrStatus: master.openCtnrStatus,
      remark: master.remark,
      warehouse: master.warehouse,
    });

    dispatch(setLoadingRedux(false));
    if (!snackBarRsp(enqueueSnackbar, result)) {
      return;
    }
    const { data: dataTemp } = result.data;
    setRandomValue(Math.random());
  };

  const handleSubmit = (e?: React.FormEvent<HTMLFormElement>) => {
    if (e && e.preventDefault) {
      e.preventDefault();
    }

    if (master.declDate.length === 0) {
      master.declDate = getDateDayPlus();
    }
    if (!master.declDateValid) {
      return;
    }
    switch (submitKey) {
      case 'upload':
        handleUpload();
        break;
      default:
        break;
    }
  };

  const updateData = async (updateObj: Iobject) => {
    setMaster({ ...master, ...updateObj });
    const key: string[] = Object.keys(updateObj);

    if (key[0] === 'chkCode1' || key[0] === 'warehouse') {
      const masterTemp = { ...master, ...updateObj };
      const { chkCode1, warehouse } = masterTemp;
      let warehouseResult = { text: '', error: false };
      let expressResult = { text: '', error: false };
      if (warehouse.length > 0) {
        warehouseResult = await getWarehouse(
          updateObj,
          master as unknown as Iobject
        );
        setWarehouseName(warehouseResult.text);
      } else {
        setWarehouseName('');
      }

      if (chkCode1.length > 0) {
        expressResult = await getExpressName(
          updateObj,
          master as unknown as Iobject
        );
        setExpressName(expressResult.text);
      } else {
        setExpressName('');
      }
      setFormError(warehouseResult.error || expressResult.error);
    }
  };

  const gridRef = useRef<any>(undefined);

  const selectFile = async (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = (e.target as HTMLInputElement).files?.item(0); // 取得選中檔案們的一個檔案
    const reader = new FileReader();
    let fileBase64 = '';
    if (file) {
      setMaster({ ...master, fileName: file.name });
      reader.readAsArrayBuffer(file);
      reader.onloadend = (evt) => {
        if (evt?.target?.readyState === FileReader.DONE) {
          const arrayBuffer = evt.target.result;
          const array = new Uint8Array(arrayBuffer as ArrayBuffer);
          for (let i = 0; i < array.length; i += 1) {
            fileBase64 += String.fromCharCode(array[i]);
          }
          setPhoto(btoa(fileBase64));
        }
      };
      setUploadFile(file);
    }
    e.target.value = '';
  };

  const handleReset = async () => {
    // const selectedNodes = gridRef.current.api.getSelectedNodes();
    // if (selectedNodes && selectedNodes.length === 0) {
    //   // this.common.messageBox('請先選擇一筆要刪除的資料!', '批次刪除');
    // } else {
    //   console.log(selectedNodes);
    // }

    setMaster(masterDefaultValue);
    setSubmitKey('search');
    setExpressName('');
    if (masterDefaultValue.warehouse.length === 0) {
      setWarehouseName('');
    }
    setPhoto('');
    setUploadFile(null);
    setOpenSearchTable(false);
    setFormError(false);
    setRandomValue(Math.random());
  };
  return (
    <div id="page-area">
      <Header />
      <form onSubmit={handleSubmit} className="form-area">
        <div>
          <div className="title">
            <EditIcon /> 開櫃影像上傳
          </div>
        </div>
        <div className="input-area">
          {userType && isType(userTypeList.admin, userType) && (
            <Grid container>
              <VcEGrid item xs={12} sm={2} className="input-text">
                <FormTitle>快遞倉站：</FormTitle>
              </VcEGrid>
              <VcGrid item xs={12} sm={3}>
                <WarehouseModal
                  value={master.warehouse}
                  updateData={updateData}
                  setStatus={setWarehouseName}
                />
              </VcGrid>

              <VcGrid item xs={12} sm={4}>
                {warehouseName && (
                  <Alert
                    severity="info"
                    style={{
                      width: '100%',
                      color: 'red',
                      margin: '0 0.5rem',
                      fontSize: '1em',
                    }}
                    icon={false}
                  >
                    {warehouseName}
                  </Alert>
                )}
              </VcGrid>
            </Grid>
          )}
          <Grid container>
            <VcEGrid item xs={12} sm={2} className="input-text">
              <FormTitle>*拆櫃日期：</FormTitle>
            </VcEGrid>
            <VcGrid item xs={12} sm={5} style={{ maxWidth: 900 }}>
              <DateOneSePickersTyping
                required
                updateData={updateData}
                style={{ maxWidth: 200 }}
                inputDataName="declDate"
                data={master}
                seInterval={31}
              />
            </VcGrid>
          </Grid>

          <Grid container>
            <VcEGrid item xs={12} sm={2} className="input-text">
              <FormTitle>*貨櫃號碼：</FormTitle>
            </VcEGrid>
            <Grid item xs={12} sm={3}>
              <Autocomplete
                freeSolo
                options={containerNoOptions}
                value={master.containerNo}
                onChange={(_, newValue) => {
                  updateData({ containerNo: newValue || '' });
                }}
                onInputChange={(_, newInputValue) => {
                  updateData({ containerNo: newInputValue || '' });
                }}
                renderInput={(params) => (
                  <Input
                    {...params}
                    required
                    name="containerNo"
                    value={master.containerNo}
                  />
                )}
              />
            </Grid>
          </Grid>

          <Grid container>
            <VcEGrid item xs={12} sm={2} className="input-text">
              <FormTitle>*開櫃狀態：</FormTitle>
            </VcEGrid>
            <Grid item xs={12} sm={3}>
              <Select
                // placeholder="請先填入分號"
                value={master.openCtnrStatus}
                onChange={selectChange(updateData)}
                name="openCtnrStatus"
                // disabled={options.length === 0}
                options={openCNStatOptions}
              />
            </Grid>
          </Grid>

          <Grid container>
            <VcEGrid item xs={12} sm={2} className="input-text">
              備註：
            </VcEGrid>
            <Grid item xs={12} sm={3}>
              <Input
                maxLength={35}
                value={master.remark}
                name="remark"
                onChange={(e) => {
                  inputChange(updateData)(e);
                }}
              />
            </Grid>
          </Grid>

          <Grid container>
            <VcEGrid item xs={12} sm={2} className="input-text">
              檔名：
            </VcEGrid>
            <Grid item xs={12} sm={3}>
              <Input
                required
                disabled={false}
                maxLength={35}
                value={master.fileName}
                name="containerNo"
                onChange={(e) => {
                  inputChange(updateData)(e);
                }}
              />
            </Grid>

            <Grid item xs={4} sm={4}>
              <input
                disabled={formError}
                accept=".jpg,.jpeg,.gif,.png"
                className={classes.input}
                id="contained-button-file"
                // multiple
                type="file"
                onChange={selectFile}
                capture="camera"
              />
              <label htmlFor="contained-button-file">
                <Button
                  disabled={false}
                  variant="contained"
                  color="default"
                  startIcon={<AttachFileIcon />}
                  component="span"
                  style={{
                    borderRadius: '20px',
                    // backgroundColor: 'blue',
                  }}
                >
                  照相
                </Button>
              </label>
            </Grid>
            <Grid item xs={8} sm={3} md={3} lg={3}>
              <input
                disabled={formError}
                accept=".jpg,.jpeg,.gif,.png"
                className={classes.input}
                id="contained-button-file2"
                // multiple
                type="file"
                onChange={selectFile}
              />
              <label htmlFor="contained-button-file2">
                <Button
                  disabled={false}
                  variant="contained"
                  color="default"
                  startIcon={<AttachFileIcon />}
                  component="span"
                  style={{
                    borderRadius: '20px',
                    whiteSpace: 'nowrap',
                    // backgroundColor: 'blue',
                  }}
                >
                  選擇圖片
                </Button>
              </label>
            </Grid>
          </Grid>
        </div>
        <Grid container className="button-area">
          <VcEGrid item xs={12} sm={8} md={6} lg={6}>
            <Button
              disabled={formError}
              type="submit"
              variant="contained"
              color="primary"
              startIcon={<SaveIcon />}
              onClick={() => setSubmitKey('upload')}
              style={{ whiteSpace: 'nowrap' }}
            >
              上傳圖片
            </Button>
          </VcEGrid>
          <Grid item xs={12} sm={4}>
            <Button
              disabled={formError}
              variant="outlined"
              color="primary"
              startIcon={<RefreshIcon />}
              onClick={() => handleReset()}
            >
              重置
            </Button>
          </Grid>
          {/*  <Typography variant="h5">目前斷點（Breakpoint）：</Typography>
           <Typography variant="h3">{currentBreakpoint}</Typography>
           <Typography variant="body1">對應裝置：{description}</Typography> */}
        </Grid>
        <Grid container>
          <div
            style={{
              color: 'red',
              fontWeight: 800,
              marginLeft: '10%',
              padding: 0,
            }}
          >
            *上傳格式僅限為jpg、gif，系統壓縮後檔案大小在300KB以下。
          </div>
        </Grid>
      </form>
    </div>
  );
};

export default UploadOpenCtnrImg;
